import { useState } from 'react';

import { Done } from '@mui/icons-material';
import { Button, Confirm, useNotify, useRefresh, useUpdate } from 'react-admin';
import { DataProviderResource } from 'src/constants';
import { OfferOversubscription } from 'src/models';

export const ApplyOfferOversubscriptionButton = ({ record }: { record: OfferOversubscription }) => {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();
  const [applyOfferOversubscription] = useUpdate<OfferOversubscription>();

  const onApply = () => {
    applyOfferOversubscription(
      DataProviderResource.ApplyOfferOversubscription,
      {
        id: record.id,
        data: {},
      },
      {
        mutationMode: 'pessimistic',
        onSuccess: () => {
          notify(`Offer oversubscription was successfully applied.`, {
            type: 'success',
            undoable: true,
          });
          onClose();
        },
        onSettled: () => {
          refresh();
        },
        onError: (error: any) => {
          notify(`${JSON.stringify(error?.message ?? error)}`, {
            type: 'error',
          });
        },
      },
    );
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const onConfirm = () => {
    onApply();
  };

  return (
    <>
      <Button
        label='apply'
        onClick={() => setIsOpen(true)}
        startIcon={<Done />}
        disabled={!record.status.isUnderReview}
        sx={{
          color: record.status.isUnderReview ? '#237804' : 'rgba(0, 0, 0, 0.87)',
          '&:hover': {
            backgroundColor: 'rgba(35, 120, 4, 0.25)',
          },
        }}
      />
      <Confirm
        isOpen={isOpen}
        title='Apply Offer Oversubscription'
        content={'Are you sure you want to apply offer oversubscription?'}
        onConfirm={onConfirm}
        onClose={onClose}
      />
    </>
  );
};
